import {Concept} from 'types';
import type {DataValue, VerifiedLinkedCatalogPostLink} from '../types';
import {isVerifiedLinkedCatalogPostLink} from './isVerifiedLinkedCatalogPostLink';

export const isVerifiedLinkedWorkLink = (
  link: DataValue | undefined,
): link is VerifiedLinkedCatalogPostLink =>
  isVerifiedLinkedCatalogPostLink(link) && link.type === Concept.work;
